import { render, staticRenderFns } from "./TrafficFine.vue?vue&type=template&id=2ebe00b0&"
import script from "./TrafficFine.vue?vue&type=script&lang=js&"
export * from "./TrafficFine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports